import React, { useMemo, useState } from 'react';
import ConversationLogger from '../components/home/ConversationLogger';
import TodayTimeline from '../components/home/TodayTimeline';
import TemplatePicker from '../components/supplements/TemplatePicker';

// The logging hub — the mic destination. One screen: tell it everything up top
// (the combo conversation, text or voice), and watch the logs from those inputs
// appear right below. Stay put as you go.

const LogPage = () => {
  const today = useMemo(() => new Date().toISOString().split('T')[0], []);
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          Log
        </h1>
        <p className="mt-2 text-base text-stone-600 dark:text-stone-300">
          Tell me what you ate, how you moved, or how you slept — I'll log it for you.
        </p>
      </div>

      <ConversationLogger
        defaultDate={today}
        onEntrySaved={() => setRefreshKey((k) => k + 1)}
      />

      <TemplatePicker
        defaultDate={today}
        onEntrySaved={() => setRefreshKey((k) => k + 1)}
      />

      <TodayTimeline refreshKey={refreshKey} />
    </div>
  );
};

export default LogPage;
